import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// ============= SENTRY =============
// Captura excepciones no controladas en el cliente y las manda a Sentry.
// Se auto-desactiva si REACT_APP_SENTRY_DSN no esta definida (local dev limpio).
// sendDefaultPii=false: no enviamos IPs ni datos personales por defecto (GDPR).
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    // 10% de transacciones para performance. Errores siempre al 100%.
    tracesSampleRate: 0.1,
    // Solo captura Session Replay si hay un error (graba el ultimo minuto previo).
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true, // enmascara texto de inputs/forms
        blockAllMedia: true, // no manda screenshots completos
      }),
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
